var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHedera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000096745422287023299710000008425786254455116467_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "chain_x2F_hedera_00000004510196703121009280000000341486510004921506_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_00000042004595305083415060000009609145574477072040_",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1_00000103965749527424736810000006007563254934047370_",
    className: "st0",
    points: "27.3,15 33.1,15 33.1,13.6  27.3,13.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2_00000127041451344437707840000015995865815042430882_",
    className: "st0",
    d: "M34.4,18.9h-1.3v-2.8h-5.8v2.8H26V9.8h1.3 v2.7h5.8V9.8h1.3L34.4,18.9L34.4,18.9L34.4,18.9z M30.2,3c-6.3,0-11.4,5.1-11.4,11.4s5.1,11.4,11.4,11.4s11.4-5.1,11.4-11.4 S36.5,3,30.2,3L30.2,3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4_00000136390510980914621630000001741263340998697872_",
    className: "st0",
    points: "58.9,13.6 52.9,13.6 52.9,9.3  51.4,9.3 51.4,19.5 52.9,19.5 52.9,15.1 58.9,15.1 58.9,19.5 60.5,19.5 60.5,9.3 58.9,9.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6_00000015342928843033607910000001695640756697900702_",
    className: "st0",
    d: "M65.7,12.2c-2.1,0-3.6,1.6-3.6,3.7 s1.6,3.7,3.7,3.7c2.5,0,3.3-1.6,3.4-2.2v-0.1h-1.4l0,0c0,0-0.5,0.9-2,0.9c-1.3,0-2.2-0.9-2.3-2.2h5.8v-0.1 C69.4,13.8,67.9,12.2,65.7,12.2 M65.7,13.4c1,0,1.7,0.5,2,1.5h-4.1C64,14,64.7,13.4,65.7,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8_00000021814183801078729690000017989113550626374061_",
    className: "st0",
    d: "M76.5,13.3c-0.4-0.5-1.2-1.1-2.5-1.1 c-2.1,0-3.5,1.5-3.5,3.7s1.4,3.7,3.5,3.7c1.4,0,2.2-0.8,2.5-1.2v1h1.4V8.9h-1.4V13.3z M74.2,18.3c-1.4,0-2.3-1-2.3-2.4 s0.9-2.4,2.3-2.4c1.3,0,2.3,1,2.3,2.4S75.6,18.3,74.2,18.3L74.2,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10_00000019641814045658135720000008568421297270497711_",
    className: "st0",
    d: "M83.2,12.2c-2.1,0-3.6,1.6-3.6,3.7 s1.6,3.7,3.7,3.7c2.5,0,3.3-1.6,3.4-2.2v-0.1h-1.4l0,0c0,0-0.5,0.9-2,0.9c-1.3,0-2.2-0.9-2.3-2.2h5.8v-0.1 C86.8,13.8,85.4,12.2,83.2,12.2 M83.2,13.4c1,0,1.7,0.5,2,1.5h-4.1C81.4,14,82.2,13.4,83.2,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12_00000067221754872038141570000009760000545302224307_",
    className: "st0",
    d: "M89.9,13.4v-1h-1.4v7.1h1.4v-4 c0-1.3,0.6-1.7,2.3-1.7h1.9v-1.4h-1.8C90.8,12.3,90.2,12.9,89.9,13.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16_00000013178121391440915260000012117214229846934948_",
    transform: "translate(539.588501, 65.401345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-14_00000163767910230529303870000004692529427224282257_",
    className: "st0",
    d: "M-439.1-52.1c-0.3-0.4-1-1.1-2.4-1.1 c-1.7,0-3.5,1.3-3.5,3.7c0,2.2,1.4,3.7,3.5,3.7c1.3,0,2.1-0.7,2.4-1.2v1h1.4v-7.1h-1.4V-52.1z M-439.1-49.5 c0,1.4-0.9,2.4-2.2,2.4c-1.3,0-2.2-1-2.2-2.4s0.9-2.4,2.2-2.4S-439.1-50.9-439.1-49.5L-439.1-49.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHedera);
export default __webpack_public_path__ + "static/media/hedera.4240e49d3cb853a1855c2d485d6fc857.svg";
export { ForwardRef as ReactComponent };